// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Exercicio } from '../comum/exercicio.model';
import { Orgao } from '../comum/orgao.model';
import { Despesa } from '../planejamento/despesa.model';
import { FichaDespesa } from '../planejamento/ficha-despesa.model';
import { Fatura } from './fatura.model';

export class FaturaDeParaFicha extends BaseResourceModel {
  constructor(
    public id?: number,
    public fatura?: Fatura,
    public taxa?: boolean,
    public juros_multa?: boolean,
    public att_monetaria?: boolean,
    public ficha_despesa_anterior?: FichaDespesa,
    public subelemento_despesa_anterior?: Despesa,
    public ficha_despesa_taxa_anterior?: FichaDespesa,
    public subelemento_despesa_taxa_anterior?: Despesa,
    public ficha_despesa_juros_anterior?: FichaDespesa,
    public subelemento_despesa_juros_anterior?: Despesa,
    public ficha_despesa_atualizacao_anterior?: FichaDespesa,
    public subelemento_despesa_atualizacao_anterior?: Despesa,
    public ficha_despesa?: FichaDespesa,
    public subelemento_despesa?: Despesa,
    public ficha_despesa_taxa?: FichaDespesa,
    public subelemento_despesa_taxa?: Despesa,
    public ficha_despesa_juros?: FichaDespesa,
    public subelemento_despesa_juros?: Despesa,
    public ficha_despesa_atualizacao?: FichaDespesa,
    public subelemento_despesa_atualizacao?: Despesa,
    public exercicio?: Exercicio,
    public orgao?: Orgao,
  ) {
    super();
  }

  static converteJson(json: any): FaturaDeParaFicha {
    return Object.assign(new FaturaDeParaFicha(), json);
  }
}
